
import { PropType } from "vue";
import mixins from "@/@core/mixins";
import MixinsUtilities from "@/@modules/csov-my-holidays/services/mixins/MixinsUtilities";
import { DynamicItem, MainMenuItem } from "../interfaces/Toolbar";

export default mixins(MixinsUtilities).extend({
  props: {
    isDeletable: Boolean,
    link: {
      type: Object as PropType<DynamicItem | MainMenuItem>,
      required: true,
    },
  },
  computed: {
    label(): string | undefined {
      return this.link.label;
    },
    popup(): string | boolean {
      if ("popup" in this.link && !!this.link.popup) {
        return this.link.popup;
      }
      return false;
    },
  },
});
